import { connect } from "react-redux";
import { currentUnhandledErrorSelector } from "~/components/UnhandledError/reducers";
import AuthenticationLayoutInternal from "./AuthenticationLayoutInternal";

const AuthenticationLayout = connect((state: GlobalState) => {
    return {
        unhandledError: currentUnhandledErrorSelector(state),
    };
})(AuthenticationLayoutInternal);

export default AuthenticationLayout;
